module.exports = __webpack_public_path__ + "img/c2.a51a6ddf.jpg";